/**
 * Fachliche Fehlermeldung eines Dienstes für die Anzeige beim Nutzer aufbereiten.
 *
 * Hintergrund: An vielen Mutationsstellen wurde der gefangene Fehler verworfen und
 * pauschal `errors.generic` gemeldet. Der Nutzer sah dann nur „Fehler", obwohl die
 * pm-api einen fachlichen Grund mitgeschickt hatte (z.B. „Rumpf unvollständig").
 * Diese Funktion bündelt das Muster, das `WorkLogFormDialog` bereits verwendet.
 *
 * Reihenfolge: Meldung des Dienstes → Meldung des Fehlers → Rückfalltext.
 *
 * Zur Einordnung gegenüber `api/client.ts`:
 * - `ApiError` erbt von `Error`; eine `instanceof Error`-Prüfung deckt beide Fälle ab.
 *   Bewusst ohne Import der Klasse, damit diese Funktion nicht an das Client-Modul
 *   gebunden ist (Tests attrappieren `api/client` häufig ohne `ApiError`-Export).
 * - Die Übersetzung des Backend-Codes und die 403-Sonderbehandlung passieren bereits
 *   in `resolveErrorMessage`, BEVOR der `ApiError` erzeugt wird. `err.message` trägt
 *   den fertigen Text also schon — hier wird nichts erneut übersetzt oder überschrieben.
 * - Anders als `formatApiError` hängt diese Funktion keine Detail-Liste an und kennt
 *   einen Rückfalltext. Sie ersetzt `formatApiError` nicht, sondern ergänzt es für die
 *   Stellen, die bisher gar nichts vom Dienst angezeigt haben.
 *
 * @param err      Der gefangene Fehler (unbekannten Typs).
 * @param fallback Text, der angezeigt wird, wenn der Dienst nichts Verwertbares liefert.
 *                 Wird nie leer zurückgegeben, solange der Aufrufer einen Text übergibt.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const message = err instanceof Error ? err.message : undefined;
  if (typeof message === 'string' && message.trim().length > 0) return message;
  return fallback;
}
